<template>
  <div class="flex flex-col w-full space-y-12">
    <div class="max-w-3xl mx-auto flex flex-col bg-white shadow p-5 w-full">
      <div class="flex space-x-2 lg:space-x-4">
        <base-input v-model.trim="companyName" label="company_name" />
        <base-input v-model.trim="companyNumber" label="company_no" />
      </div>
      <base-button
        @click="search"
        action="search"
        class="mt-2"
        :disabled="fetching || !canSubmitSearchForm"
      />
      <FormError :errors="searchErrors" class="mt-6" />
    </div>
    <base-loader :fetching="fetching" />
    <div class="w-full max-w-6xl mx-auto">
      <div v-if="crm.length > 0" class="space-y-4">
        <base-card v-for="(company, i) in filteredCrm" :key="i" size="sm">
          <!-- Company details -->
          <div class="py-4 sm:flex items-center border-b">
            <span class="sm:w-2/5 leading-5 text-secondary-dark"
              >{{ $t('mygwf.components.Form.name') }}:</span
            >
            <span class="leading-5 sm:mt-0">{{ company.name }}</span>
          </div>
          <div class="py-4 sm:flex items-center border-b">
            <span class="sm:w-2/5 leading-5 text-secondary-dark"
              >{{ $t('mygwf.components.Form.customer_account') }}:</span
            >
            <span class="leading-5 sm:mt-0">{{ company.area }}-{{ company.customer_account }}</span>
          </div>
          <div class="py-4 sm:flex items-center border-b">
            <span class="sm:w-2/5 leading-5 text-secondary-dark"
              >{{ $t('mygwf.components.Form.address') }}:</span
            >
            <span class="leading-5 sm:mt-0">{{ company.address }}</span>
          </div>
          <div class="py-4 sm:flex items-center border-b">
            <span class="sm:w-2/5 leading-5 text-secondary-dark"
              >{{ $t('mygwf.components.Form.city') }}:</span
            >
            <span class="leading-5 sm:mt-0">{{ company.city }}</span>
          </div>
          <div class="py-4 sm:flex items-center border-b">
            <span class="sm:w-2/5 leading-5 text-secondary-dark"
              >{{ $t('mygwf.components.Form.country') }}:</span
            >
            <span class="leading-5 sm:mt-0">{{ getCountryName(company.country) }}</span>
          </div>
          <div class="py-4 sm:flex items-center border-b">
            <span class="sm:w-2/5 leading-5 text-secondary-dark"
              >{{ $t('mygwf.components.Form.zip') }}:</span
            >
            <span class="leading-5 sm:mt-0">{{ company.zip }}</span>
          </div>
          <div class="py-4 sm:flex items-center">
            <span class="sm:w-2/5 leading-5 text-secondary-dark"
              >{{ $t('mygwf.components.Form.representative') }}:</span
            >
            <span class="leading-5 sm:mt-0">{{ company.representative }}</span>
          </div>
          
          

          <!-- Action buttons -->
          <div class="flex justify-end items-center pt-5 pb-3 border-t">
            <base-alert
              v-if="companyExists(company.customer_account)"
              class="company-exist-alert"
              type="success"
              text="company_exists"
            />
            <base-button
              v-else
              :loading="isImporting === i"
              action="import_company"
              @click="importCompany(i)"
            >
              <base-icon icon="import" class="text-lg" />
            </base-button>
          </div>
        </base-card>
      </div>
      <base-alert v-if="crm.length === 10" type="info" text="narrow_search" class="mt-10" />
      <div v-if="!fetching && fetched && crm.length === 0" class="py-10 text-center font-semibold">
        {{ $t(`mygwf.components.Grid.no_results`) }}
      </div>
    </div>
  </div>
</template>

<script>
import {BaseCard, BaseIcon, BaseLoader, BaseInput, BaseAlert, BaseButton} from '@/components/base'
import {getCountryName} from '@/state/helpers/mixins.js'

export default {
  components: {
    BaseButton,
    BaseLoader,
    BaseInput,
    BaseAlert,
    BaseIcon,
    BaseCard,
    FormError: () => import('@/components/shared/FormError.vue'),
  },

  data() {
    return {
      companyName: '',
      companyNumber: '',
      fetching: false,
      crm: [],
      fetched: false,
      searchErrors: {},
      isImporting: -1,
    }
  },

  computed: {
    filteredCrm() {
      return this.crm.length > 1 ? this.crm.filter(company => company.customer_account) : this.crm
    },
    canSubmitSearchForm() {
      return [this.companyName, this.companyNumber].some(e => e !== '')
    },
  },

  mixins: [getCountryName],

  methods: {
    async search() {
      let body = {}
      if (this.name !== '') {
        body = {name: this.companyName}
      }
      if (this.companyNumber !== '') {
        body = {...this.body, ...{customer_account: this.companyNumber}}
      }
      this.fetching = true
      this.searchErrors = {}
      try {
        const data = await this.$store.dispatch('companies/importCrm', body)
        this.fetched = true
        if (Array.isArray(data)) {
          this.crm = data
        } else {
          this.crm = []
        }
      } catch (error) {
        this.crm = []
        this.fetched = false
        this.searchErrors = error
      }
      this.fetching = false
    },

    importCompany(i) {
      this.isImporting = i
      this.$store
        .dispatch('companies/createFromCrm', this.crm[i])
        .then(data => {
          this.$store.dispatch('app/notification', {type: 'success', group: 'app', text: `created`})
        })
        .catch(error => {
          //this.$store.dispatch('app/notification', { type: 'error', group: 'app', text: `already_exists` })
        })
        .finally(() => (this.isImporting = -1))
    },

    companyExists(id) {
      return id && this.$store.getters['companies/crmAccounts'].includes(id)
    },
  },
}
</script>

<style scoped>
.company-exist-alert {
  margin-bottom: 0 !important;
}
</style>
